(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-steps"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  if(window.Shopify && window.Shopify.designMode) return;

  /* ── STACK STATES ───────────────────────────────────────────
     Only ONE card is fully visible at a time (depth 0).
     Back cards are nearly invisible — just enough to show
     the "stacked deck" effect peeking below the front card.
     All cards have solid backgrounds so there is NO bleed-through.
  ────────────────────────────────────────────────────────────── */
  function stateAt(d){
    if(d < 0) return {sc:1.10, ty:-30, op:0};      /* gone — slide up and fade */
    if(d===0) return {sc:1.00, ty:0,   op:1.00};    /* FRONT — full and opaque  */
    if(d===1) return {sc:0.96, ty:12,  op:1.00};    /* peek 1 — hidden by front */
    if(d===2) return {sc:0.92, ty:24,  op:1.00};    /* peek 2 — hidden by front */
    return           {sc:0.88, ty:36,  op:0};       /* too far — hidden         */
  }

  function easeOut(t){ t=Math.max(0,Math.min(1,t)); return 1-Math.pow(1-t,3); }
  function lerp(a,b,t){ return a+(b-a)*t; }

  function paintDeck(cards, gp){
    var n=cards.length;
    gp=Math.max(0,Math.min(n-1,gp));
    var f=Math.floor(gp);
    var p=easeOut(gp-f);

    cards.forEach(function(card,i){
      var d0=i-f, d1=d0-1;
      var a=stateAt(d0), b=stateAt(d1);

      var sc=lerp(a.sc,b.sc,p);
      var ty=lerp(a.ty,b.ty,p);
      var op=lerp(a.op,b.op,p);

      /* ── Z-INDEX LOGIC ──────────────────────────────────────
         To make the passed card "move backward", we must drop
         its z-index below the incoming card after the midpoint.
      ────────────────────────────────────────────────────────── */
      var zi = (i >= gp) ? (100 - i) : (10 - i);

      card.style.transform='translateY('+ty.toFixed(2)+'px) scale('+sc.toFixed(4)+')';
      card.style.opacity=Math.max(0,op).toFixed(3);
      card.style.zIndex=String(zi);
      /* Only the currently foremost card should be clickable */
      card.style.pointerEvents= (i === f && gp-f < 0.5) || (i === f+1 && gp-f >= 0.5) ? 'auto' : 'none';
    });
  }

  function initSection(root){
    var track=root.querySelector('[data-scs-track]');
    var n=parseInt(root.getAttribute('data-scs-total'),10);
    if(!track||!n) return;

    /* Build logical card array [Card0, Card1, Card2...] from reversed DOM */
    var els=Array.from(root.querySelectorAll('[data-card]'));
    var cards=new Array(n);
    els.forEach(function(el){
      var idx=parseInt(el.getAttribute('data-card'),10);
      if(!isNaN(idx)) cards[idx]=el;
    });

    function setH(){ track.style.height=(n*window.innerHeight)+'px'; }

    function getProgress(){
      var top=-track.getBoundingClientRect().top;
      var max=track.offsetHeight-window.innerHeight;
      if(max<=0||top<=0) return 0;
      return Math.min(n-1,(top/max)*(n-1));
    }

    var raf=null;
    function render(){ paintDeck(cards,getProgress()); }
    function onScroll(){ if(raf)return; raf=requestAnimationFrame(function(){ render(); raf=null; }); }
    function onResize(){ setH(); render(); }

    /* ALWAYS start with Card 1 as front — never read scroll on initial paint */
    setH();
    paintDeck(cards, 0);

    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onResize,{passive:true});

    document.addEventListener('shopify:section:unload',function(e){
      if(e.target===root||e.target.contains(root)){
        window.removeEventListener('scroll',onScroll);
        window.removeEventListener('resize',onResize);
        if(raf) cancelAnimationFrame(raf);
      }
    });
    document.addEventListener('shopify:block:select',function(e){
      var idx=parseInt(e.target.getAttribute('data-card'),10);
      if(isNaN(idx)||n<2) return;
      var top=track.getBoundingClientRect().top+window.pageYOffset;
      window.scrollTo({top:top+(idx/(n-1))*(track.offsetHeight-window.innerHeight),behavior:'smooth'});
    });
  }

  function boot(){ document.querySelectorAll('[data-scs-root]').forEach(initSection); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',function(e){ var s=e.target.querySelector('[data-scs-root]'); if(s) initSection(s); });

}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
